import React, { useMemo, useEffect, useState, useLayoutEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Beat } from "../../../../../plugins/spinners.plugin";
import Button from "../../../../../components/buttons/buttons";
import Card from "../../../../../components/cards/admin/cards";
import Table from "../../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../../components/skeleton/table";
import { Pagination } from "../../../../../components/pagination/pagination";
import EmptyState from "../../../../../assets/images/emptyState/report.svg";
import { ReactComponent as Chart } from "../../../../../assets/images/icons/chart.svg";
import { AllFiltersModal } from "../../../../../components/modals/allFiltersModal";
import FilterRestaurantOrdersDropDown from "../../../../../components/dropDown/filter/filterRestaurantOrders";
import {
  filterRestaurantOrderAction,
  searchRestaurantOrderAction,
  getAllRestaurantOrdersNoPagination,
} from "../../../../../redux/restaurantOrder/restaurantOrderActions";
import restaurantType from "../../../../../redux/restaurantOrder/restaurantOrderTypes";
import { writeFileWithXLSX } from "../../../../../components/exports/xlsx";

function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function Closed() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { page, outlet } = useParams();
  let lastMonth = new Date();
  lastMonth.setDate(lastMonth.getDate() - 30);

  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
  });
  const [payLoad] = useState({
    status: "closed",
    restaurant_id: outlet,
  });

  const { allOrders, downloading, filtering, searching } = useSelector(
    (state) => state.restaurantOrder
  );

  useEffect(() => {
    dispatch(filterRestaurantOrderAction(payLoad, page));
    // eslint-disable-next-line
  }, [page]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((order) => {
        let show = {
          invoice: order?.id,
          createdAt: moment(order?.created_at).format("MMM DD, YYYY"),
          amount: <span>NGN {numberWithCommas(order?.order_amount)}</span>,
          paid: (
            <span>
              {order?.order_paid ? (
                <span className="text-[#00D220] font-bold">Paid</span>
              ) : (
                <span className="text-primary font-bold">Not Paid</span>
              )}
            </span>
          ),
          status: <p className="text-[#046ECF] font-bold">{order?.status}</p>,
          recipient: order?.recipient_name,
          orderData: order,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  function createTableDataDownload(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((order) => {
        let show = {
          invoice: order?.id,
          createdAt: moment(order?.created_at).format("MMM DD, YYYY"),
          amount: order?.order_amount,
          paid: order?.order_paid ? "Paid" : "Not Paid",
          status: order?.status,
          recipient: order?.recipient_name,
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  useLayoutEffect(() => {
    const dataSet = createTableData(allOrders?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allOrders]);

  function goToSinglePage(params) {
    let id = params?.show?.orderData?.id;
    navigate(`/admin/orders-report/restaurant/details/${id}`, {
      state: { food: params?.show?.orderData },
    });
  }

  const handleDownload = async () => {
    const response = await dispatch(
      getAllRestaurantOrdersNoPagination({
        ...payLoad,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableDataDownload(response?.data);
      writeFileWithXLSX(newData, {
        filename: "OrdersReport_Restaurant_Closed.xlsx",
        download: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allOrders?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: restaurantType["SEARCH_RESTAURANT_ORDERS"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchRestaurantOrderAction(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "Invoice No",
            accessor: "show.invoice",
          },
          {
            Header: "Date Created",
            accessor: "show.createdAt",
          },
          {
            Header: "Amount",
            accessor: "show.amount",
          },
          {
            Header: "Payment Status",
            accessor: "show.paid",
          },
          {
            Header: "Order Status",
            accessor: "show.status",
          },
          {
            Header: "Customer Name",
            accessor: "show.recipient",
          },
        ],
      },
    ],
    []
  );
  return (
    <div>
      <Card.TableFilter
        title={"Restaurants"}
        results={allOrders?.to}
        totalResults={allOrders?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        searchPlaceholder={"Customer name or Outlet name"}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterRestaurantOrdersDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
      >
        <Button.Primary
          type="button"
          title={
            <span className="flex gap-1 items-center">
              <Chart />
              Check Stats
            </span>
          }
          onClick={() =>
            navigate(`/admin/orders-report/restaurant/${outlet}/statistics`)
          }
        />
        <Button.Secondary
          title={downloading ? <Beat color={"#CE2600"} /> : "Download CSV"}
          type="button"
          onClick={handleDownload}
          disabled={!data}
        />
      </Card.TableFilter>

      <div className="border-b border-[#E4E4F3] dark:border-[#505050]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="py-36 text-center">
            <div className="flex justify-center">
              <img src={EmptyState} className="w-auto" alt="no data" />
            </div>
            <h3 className="mt-5 text-xl font-bold">Reports</h3>
            <p className="mt-2 text-sm text-[#9CA3AF]">
              You do not have any report records yet.
            </p>
          </div>
        )}

        {!isSearchOpen && (
          <Pagination
            data={allOrders}
            route={`admin/orders-report/restaurant/${outlet}/closed`}
          />
        )}
      </div>
    </div>
  );
}
